import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	FormFeedback,
	FormGroup,
	ModalFooter,
	Card,
	CardBody,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
// import { addNewGuideDetail, updateGuideDetail } from '../../../../slices/guideDetail/thunk';
// import { setRequireCloseModal } from '../../../../slices/guideDetail/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GeneralSelect from '../../../../../Components/General/Selects/GeneralSelect';
import { getResidueCategoryList, getResidueList, getUnitMeasurementList } from '../../../../../helpers/residue/backend_helper';
import OSelect from '../../../../../Components/OElements/OSelect';
// import { getGuideDetailCategoryList, getGuideDetailTypeList } from '../../../../helpers/guideDetail/backend_helper';
// import { getGuideDetailTypeList } from '../../../../helpers/guideDetail/backend_helper';

const GuideDetailForm = ({
	finalDestinationSelected,
	residueType,
	dataGuideDetail,
	handleDataGuideDetail,
	isEdit,
	handleIsEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	guideDetailsList,
	handlerGuideDetailsList
}) => {
	const dispatch = useDispatch();

	const [selectedGuideDetailCategory, setSelectedGuideDetailCategory] = useState(null);
	const handleGuideDetailCategorySelected = (optionSelected) => {
		setSelectedGuideDetailCategory(optionSelected);
	};

	const [selectedResidueCategory, setSelectedResidueCategory] = useState(null);
	const handleResidueCategorySelected = (optionSelected) => {
		setSelectedResidueCategory(optionSelected);
	};

	const [selectedResidue, setSelectedResidue] = useState(null);
	const handleResidueSelected = (optionSelected) => {
		setSelectedResidue(optionSelected);
	};

	const [selectedUnitMeasurement, setSelectedUnitMeasurement] = useState(null);
	const handleUnitMeasurementSelected = (optionSelected) => {
		setSelectedUnitMeasurement(optionSelected);
	};

	const [disabledCheck, setDisabledCheck] = useState(dataGuideDetail?.disable);

	function handlerItemGuideDetail(newGuideDetail, ) {
		let residueAdded = false;
		const guideDetailFounded = guideDetailsList.find(guideDetail => (guideDetail.residue.id == newGuideDetail.residue.id && guideDetail.residue.name === newGuideDetail.residue.name));
		if (!guideDetailFounded && !isEdit) {
			handlerGuideDetailsList([...guideDetailsList, newGuideDetail]);
			residueAdded = true;
			toast.success(`Residuo ${newGuideDetail.residue.name} agregado exitosamente.`, { autoClose: 3000 });
		}
		if (guideDetailFounded && isEdit) {
			const updatedGuideDetailList = guideDetailsList.map(guideDetail => {
				if (guideDetail.residue.id == newGuideDetail.residue.id && guideDetail.residue.name === newGuideDetail.residue.name) {
					return { ...guideDetail, ...newGuideDetail }
				} else {
					return guideDetail
				}
			});
			handlerGuideDetailsList(updatedGuideDetailList);
			residueAdded = true;
			toast.success(`Residuo "${newGuideDetail.residue.name}" actualizado exitosamente.`, { autoClose: 3000 });
		}
		if (guideDetailFounded && !isEdit) {
			toast.error(`Ya existe un detalle con el residuo "${newGuideDetail.residue.name}".`, { autoClose: 3000 });
		}

		return residueAdded;
	}

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			residue_category_id: '',
			residue_id: '',
			unit_measurement_id: '',
			amount: dataGuideDetail?.amount || '',
			residue_kilograms: dataGuideDetail?.residue_kilograms || '',
			residue_collected_kilograms: dataGuideDetail?.residue_collected_kilograms ||''
		},
		validationSchema: Yup.object({
			residue_category_id: Yup.string().required('Campo requerido'),
			residue_id: Yup.string().required('Campo requerido'),
			residue_kilograms: Yup.number(),
			unit_measurement_id: Yup.string().required('Campo requerido'),
			amount: Yup
				.number()
				.required('Campo requerido')
				.test(
					'Validación cantidad mínima', 
					`La cantidad debe ser mayor a 0`, 
					(value) => value >= 0
					
				)
		}),
		onSubmit: values => {
			if (isEdit) {
				const updatedGuideDetail = {
					...dataGuideDetail,
					id: dataGuideDetail._id,
					residue_category_id: values.residue_category_id,
					residue_id: values.residue_id,
					residue: selectedResidue,
					unit_measurement_id: values.unit_measurement_id,
					unit_measurement: selectedUnitMeasurement,
					amount: values.amount,
					residue_kilograms: values.residue_kilograms,
					kilograms_total: values.residue_kilograms + dataGuideDetail.residue_collected_kilograms,
					residue_collected_ids: dataGuideDetail?.residue_collected_ids || []
				};
				const isAdded = handlerItemGuideDetail(updatedGuideDetail, true);
				if(values.onlySave && isAdded){
					handleToggleModal(!isOpen);
				}
				if(isAdded){
					validation.setFieldValue('residue_id', '');
					validation.setFieldValue('unit_measurement_id', '');
					validation.setFieldValue('amount', '');
					validation.setFieldValue('total', '');
					validation.setFieldValue('kilograms_total', '');
					validation.setFieldTouched(
						'amount',
						false
					);
					handleDataGuideDetail(null);
					handleIsEdit(false);
				}
			} else {
				const newGuideDetail = {
					residue_category_id: values.residue_category_id,
					residue_id: values.residue_id,
					residue: selectedResidue,
					unit_measurement_id: values.unit_measurement_id,
					unit_measurement: selectedUnitMeasurement,
					amount: values.amount,
					residue_kilograms: values.residue_kilograms,
					residue_collected_kilograms: 0,
					kilograms_total: values.residue_kilograms,
					residue_collected_ids: []
				};
				const isAdded = handlerItemGuideDetail(newGuideDetail, false);
				if(values.onlySave && isAdded){
					handleToggleModal(!isOpen);
				}
				if(isAdded){
					validation.setFieldValue('residue_id', '');
					validation.setFieldValue('unit_measurement_id', '');
					validation.setFieldValue('amount', '');
					validation.setFieldValue('total', '');
					validation.setFieldValue('kilograms_total', '');
					validation.setFieldTouched(
						'amount',
						false
					);
				}
			}
		},
	});

	useEffect(() => {
		if (validation.values.amount) {
			const totalResidue = calculateTotal(validation.values.amount);
			const total = (
				calculateTotal(validation.values.amount) + 
				(isEdit ? dataGuideDetail.residue_collected_kilograms : 0)
			);
			validation.setFieldValue('residue_kilograms', totalResidue);
			validation.setFieldValue('kilograms_total', total);
		}
	}, [validation.values.amount]);

	const calculateTotal = (amount) => {
		// Implement the logic to calculate the total based on the amount
		// For now, assuming 1:1 conversion for simplicity
		return amount;
	};

	function handleSaveGuideDetail(onlySave){
		validation.setFieldValue('onlySave', onlySave, false);
		if(Object.keys(validation.errors).length != 0){
			toast.error(
				'Se han detectado errores en los datos del formulario. Por favor verifique los datos nuevamente.',
				{ autoClose: 4000 }
			);
		}
		validation.handleSubmit();
	}

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={12}>
								<OSelect
									key={`${dataGuideDetail?.residue?.residue_category_id}${residueType?._id}` || ''}
									label='Categoría de Residuo'
									id='residue_category_id'
									name='residue_category_id'
									value={dataGuideDetail?.residue?.residue_category_id || ''}
									// handleLabelOptions={(item) => `field`}
									onSelect={handleResidueCategorySelected}
									requestApi={() => getResidueCategoryList({
										residue_type_id: (
											residueType
												? residueType
												: ''
										),
										final_destination_id: finalDestinationSelected
									})}
									disabled={(
										isEdit
										? true
										: false
									)}
									validation={validation}
								/>
							</Col>
							<Col lg={12}>
								<OSelect
									key={`${dataGuideDetail?.residue?._id}${validation.values['residue_category_id']}` || ''}
									label='Residuo'
									id='residue_id'
									name='residue_id'
									value={dataGuideDetail?.residue?._id || ''}
									// handleLabelOptions={(item) => `field`}
									onSelect={handleResidueSelected}
									requestApi={() => getResidueList({
										residue_category_id: validation.values['residue_category_id']
									})}
									disabled={(
										validation.values['residue_category_id'] == '' ||
										isEdit
										? true : false
									)}
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={dataGuideDetail?.unit_measurement?._id || ''}
									label='Unidad de Medida'
									id='unit_measurement_id'
									name='unit_measurement_id'
									value={dataGuideDetail?.unit_measurement?._id || ''}
									// handleLabelOptions={(item) => `field`}
									onSelect={handleUnitMeasurementSelected}
									requestApi={() => getUnitMeasurementList()}
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<Label for='amount' className='form-label'>
									Cantidad
								</Label>
								<Input
									name='amount'
									id='amount'
									className='form-control'
									placeholder='Ingrese una cantidad'
									type='number'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.amount || ''}
									invalid={
										validation.touched.amount &&
											validation.errors.amount
											? true
											: false
									}
								/>
								{
									validation.touched.amount &&
										validation.errors.amount ? (
										<FormFeedback type='invalid'>
											{validation.errors.amount}
										</FormFeedback>
									) : null
								}
							</Col>
							<Col lg={4}>
								<Label for='residue_kilograms' className='form-label'>
									Total
								</Label>
								<Input
									name='residue_kilograms'
									id='residue_kilograms'
									className='form-control'
									type='number'
									disabled
									value={validation.values.residue_kilograms || ''}
									invalid={
										validation.touched.residue_kilograms &&
											validation.errors.residue_kilograms
											? true
											: false
									}
								/>
								{
									validation.touched.residue_kilograms &&
										validation.errors.residue_kilograms ? (
										<FormFeedback type='invalid'>
											{validation.errors.residue_kilograms}
										</FormFeedback>
									) : null
								}
							</Col>
							<div className='px-2 mb-0'>
								<Card className='border mb-0'>
									<CardBody>
										<Row>
										<Col lg={4}>
											<Label for='residue_kilograms' className='form-label'>
												Kg. Guía
											</Label>
											<Input
												name='residue_kilograms'
												id='residue_kilograms'
												className='form-control'
												type='number'
												disabled
												value={validation.values.residue_kilograms || ''}
												invalid={
													validation.touched.residue_kilograms &&
														validation.errors.residue_kilograms
														? true
														: false
												}
											/>
											{
												validation.touched.residue_kilograms &&
													validation.errors.residue_kilograms ? (
													<FormFeedback type='invalid'>
														{validation.errors.residue_kilograms}
													</FormFeedback>
												) : null
											}
										</Col>
										<Col lg={4}>
											<Label for='residue_collected_kilograms' className='form-label'>
												Kg. Limpiezas De Playa
											</Label>
											<Input
												name='residue_collected_kilograms'
												id='residue_collected_kilograms'
												className='form-control'
												type='number'
												disabled
												value={validation.values.residue_collected_kilograms || ''}
												invalid={
													validation.touched.residue_collected_kilograms &&
														validation.errors.residue_collected_kilograms
														? true
														: false
												}
											/>
											{
												validation.touched.residue_collected_kilograms &&
													validation.errors.residue_collected_kilograms ? (
													<FormFeedback type='invalid'>
														{validation.errors.residue_collected_kilograms}
													</FormFeedback>
												) : null
											}
										</Col>
										<Col lg={4}>
											<Label for='kilograms_total' className='form-label'>
												Total Kilogramos
											</Label>
											<Input
												name='kilograms_total'
												id='kilograms_total'
												className='form-control'
												type='number'
												disabled
												value={validation.values.kilograms_total || ''}
												invalid={
													validation.touched.total &&
														validation.errors.kilograms_total
														? true
														: false
												}
											/>
											{
												validation.touched.kilograms_total &&
													validation.errors.kilograms_total ? (
													<FormFeedback type='invalid'>
														{validation.errors.kilograms_total}
													</FormFeedback>
												) : null
											}
										</Col>
										</Row>
									</CardBody>
									
								</Card>
							</div>
							
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<ModalFooter>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='button'
						className='btn btn-label btn-primary'
						onClick={() => {
							handleSaveGuideDetail(true)
						}}
					>
						<i className='ri-save-line label-icon'></i>
						Guardar
					</button>
					<button
						type='button'
						className='btn btn-label btn-primary btn-save-and-continue'
						onClick={() => {handleSaveGuideDetail(false)}}
					>
						<i className='ri-save-line label-icon'></i>
						Guardar y continuar agregando
					</button>
				</div>
			</ModalFooter>
		</Form>
	);
};

export default GuideDetailForm;
